<script setup>
  import ListeAdmin from '@/components/ListeAdmin.vue'

</script>

<template>
  <h1>Liste des actions</h1>
  <div class="home">
    <ListeAdmin/>
  </div>
</template>

<script>


export default {

}
</script>

<style>


</style>
